enum SkcDeviceCommandEnum {
	Unlock = 'unlock',
	EnableOfficeMode = 'enableOfficeMode', // skcCommand: officeMode
	DisableOfficeMode = 'disableOfficeMode', // skcCommand: lock
	Reboot = 'reboot',
}

export default SkcDeviceCommandEnum;
